
Array.prototype.clear = function ( this: Array<any> ): void {
    this.splice( 0, this.length);
};

Array.prototype.add = function ( this: Array<any>, item ): void {
    this.push( item );
};

Array.prototype.hasRows= function ( this: Array<any> ): boolean {
    return this.length > 0;
};

